import { observable } from 'mobx'
import { Model, type ModelProps } from '@/infra/model'
import { Id } from '@/infra/id'
import { unixEpoch } from '@/utils/date-util'
import { ContactInfo } from '@/features/jobs/info-gathering/ContactInfo'
import { PersonalInfo } from './PersonalInfo'

export type SpousalProfileVersionProps = ModelProps<SpousalProfileVersion>

/**
 * A version of a spousal profile.
 */
export class SpousalProfileVersion extends Model<SpousalProfileVersion> {
  id = Id.none

  @observable accessor version = 0
  @observable accessor workspaceId = Id.none
  @observable accessor ownerUserId = Id.none
  @observable accessor occupation = ''
  @observable accessor createdAt = unixEpoch()
  @observable accessor updatedAt = unixEpoch()
  @observable.shallow accessor personalInfo: PersonalInfo = PersonalInfo.empty
  @observable.shallow accessor contactInfo: ContactInfo = ContactInfo.empty
}

/**
 * Formats an ID string for the backing collection of spousal
 * profile versions.
 */
export const SpousalProfileVersionId = {
  from: (id: Id, version: number | undefined): string => {
    if (version === undefined) {
      throw new TypeError('Profile version ID cannot be undefined')
    }

    return `${Id.assert(id)}@v${version}`
  },
}
